module.exports = __webpack_public_path__ + "static/hero-hr-blog-mobile-20b6abd7112b4ec1619ce105170c6bff.png";